import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { lazy } from 'react';
import DeliveryDetails from './delivery-details';
import GoodsLoadingDetails from './goods-loading-details';
import { PageTitle } from '../../../umart_admin/layout/core';
const AllOrders = lazy(() => import('./all-orders'));
const OrderDetails = lazy(() => import('./order-details'));
const AddNewOrder = lazy(() => import('./place-order/add-new-order'));
const EditOrder = lazy(() => import('./edit-order'));
const Index = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="*"
          element={<Navigate to="/error/404" />}
        />
        <Route
          index
          element={
            <>
              <PageTitle
                showHeading
                breadcrumbs={[]}
              >
                Orders & Delivery
              </PageTitle>
              <AllOrders />
            </>
          }
        />
        <Route
          path="order-details"
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Orders & Delivery',
                    path: '/orders',
                    isSeparator: false,
                    isActive: false,
                  },
                ]}
              >
                Order Details
              </PageTitle>
              <OrderDetails />
            </>
          }
        />
        <Route
          path="delivery-details"
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Orders & Delivery',
                    path: '/orders',
                    isSeparator: false,
                    isActive: false,
                  },
                ]}
              >
                Delivery Details
              </PageTitle>
              <DeliveryDetails />
            </>
          }
        />
        <Route
          path="goods-loading-details"
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Orders & Delivery',
                    path: '/orders',
                    isSeparator: false,
                    isActive: false,
                  },
                ]}
              >
                Goods Loading Details
              </PageTitle>
              <GoodsLoadingDetails />
            </>
          }
        />
        <Route
          path="add-new-order"
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Orders & Delivery',
                    path: '/orders',
                    isSeparator: false,
                    isActive: false,
                  },
                ]}
              >
                Add New Order
              </PageTitle>
              <AddNewOrder />
            </>
          }
        />
        <Route
          path="edit-order"
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Orders & Delivery',
                    path: '/orders',
                    isSeparator: false,
                    isActive: false,
                  },
                ]}
              >
                Edit Order
              </PageTitle>
              <EditOrder />
            </>
          }
        />
      </Route>
    </Routes>
  );
};
export default Index;
